import I18n from '~/i18n';

export const USERS_DOWNLOAD_APPOINTMENTS = process.env.REACT_APP_USERS_DOWNLOAD_APPOINTMENTS || '112151,1,31345,97,101,33115,31038,99,114080';
export const USERS_DOWNLOAD_ATTACHMENT = process.env.REACT_APP_USERS_DOWNLOAD_ATTACHMENT || '112151,1,31345,97,101,33115,31038,99,114080, 129359';

export const packageOptions = {
  users: I18n.t('constants.packages.users'),
  emergency: I18n.t('constants.packages.emergency'),
  driving: I18n.t('constants.packages.driving'),
  doctor: I18n.t('constants.packages.doctor'),
  doctor_all: I18n.t('constants.packages.doctor_all'),
  pack: I18n.t('constants.packages.pack'),
};

export const appointmentRatingOptions = {
  all: I18n.t('constants.appointmentRating.all'),
  doctor: I18n.t('constants.appointmentRating.doctor'),
  attendant: I18n.t('constants.appointmentRating.attendant'),
}

export const activeOptions = {
  actives: I18n.t('actives'),
  not_actives: I18n.t('not_actives'),
  both: I18n.t('both'),
};

export const maritalStatusOptions = {
  single: I18n.t('constants.maritalStatus.single'),
  engaged: I18n.t('constants.maritalStatus.engaged'),
  married: I18n.t('constants.maritalStatus.married'),
  divorced: I18n.t('constants.maritalStatus.divorced'),
  separated: I18n.t('constants.maritalStatus.separated'),
  widowed: I18n.t('constants.maritalStatus.widowed'),
  other: I18n.t('constants.maritalStatus.other'),
};

export const packagesColors = {
  users: '#00A4FF',
  emergency: '#FC4B4B',
  driving: '#336699',
  doctor: '#07D5C0',
  doctor_all: '#07D5C0',
  pack: '#6E40C9',
};

export const pinStatusOptions = {
  availabled: I18n.t('constants.pinStatus.availabled'),
  enabled_ecommerce: I18n.t('constants.pinStatus.enabled_ecommerce'),
  enabled_phisycal: I18n.t('constants.pinStatus.enabled_phisycal'),
  canceled: I18n.t('constants.pinStatus.canceled'),
  enabled_by_user: I18n.t('constants.pinStatus.enabled_by_user'),
  enabled_by_admin: I18n.t('constants.pinStatus.enabled_by_admin'),
  disabled_by_api: I18n.t('constants.pinStatus.disabled_by_api'),
  created: I18n.t('constants.pinStatus.created'),
};

export const genresOptions = {
  male: I18n.t('constants.genres.male'),
  female: I18n.t('constants.genres.female'),
  not_specified: I18n.t('constants.genres.not_specified'),
};

export const epayTransactionStatusOptions = {
  successfully: I18n.t('constants.epayTransactionStatus.successfully'),
  successfully_ecommerce: I18n.t('constants.epayTransactionStatus.successfully_ecommerce'),
  successfully_phisycal: I18n.t('constants.epayTransactionStatus.successfully_phisycal'),
  canceled: I18n.t('constants.epayTransactionStatus.canceled'),
  successfully_canceled: I18n.t('constants.epayTransactionStatus.successfully_canceled'),
  failed: I18n.t('constants.epayTransactionStatus.failed'),
};
